/*=========================================================================================
  File Name: moduleReportActions.js
  Description: Report Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import axios from '@/plugins/axios';
import { mapState } from 'vuex';

export default {
  getProductReports({}, payload) {
    let brand = payload.brand ? payload.brand : '';
    let category = payload.category ? payload.category : '';
    let supplier = payload.supplier ? payload.supplier : '';
    let url = `reports/products?`;
    if (payload.brand) {
      url = url + `brand=${brand}&`;
    }
    if (payload.category) {
      url = url + `category=${category}&`;
    }
    if (payload.supplier) {
      url = url + `supplier=${supplier}&`;
    }
    if (payload.query) {
      url = url + `query=${payload.query}&`;
    }
    if (payload.row) {
      url = url + `row=${payload.row}&`;
    }

    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  getShopProductReports({}, payload) {
    let brand = payload.brand ? payload.brand : '';
    let category = payload.category ? payload.category : '';
    let supplier = payload.supplier ? payload.supplier : '';
    let url = `reports/shops/${payload.shopId}/products?`;
    if (payload.brand) {
      url = url + `brand=${brand}&`;
    }
    if (payload.category) {
      url = url + `category=${category}&`;
    }
    if (payload.supplier) {
      url = url + `supplier=${supplier}&`;
    }
    if (payload.query) {
      url = url + `query=${payload.query}&`;
    }
    if (payload.row) {
      url = url + `row=${payload.row}&`;
    }

    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetWarehouseProducts({}, payload) {
    let url = `dashboard/warehouses/${payload.warehouseId}/products?`;
    if (payload.query) {
      url = url + `query=${payload.query}&`;
    }
    if (payload.warehouseId) {
      url = url + `warehouse_id=${payload.warehouseId}&`;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetShopStockDetails({}, payload) {
    let url = `dashboard/daily-stocks/shops/${payload.shopId}?date=${payload.query}`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetWarehouseStocks({}, payload) {
    let url = `dashboard/daily-stocks/warehouses/${payload.warehouseId}?date=${payload.query}`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetWarehouseExpiredProducts({}, payload) {
    let url = `dashboard/warehouses/${payload.warehouseId}/expired-items`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetWarehouseDamagedProducts({}, payload) {
    let url = `dashboard/warehouses/${payload.warehouseId}/damage-items`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetShopExpiredProducts({}, payload) {
    let url = `dashboard/shops/${payload.shopId}/expired-items`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  getPurchaseReports({}, payload) {
    let supplier = payload.supplier ? payload.supplier : '';
    let warehouse = payload.warehouse ? payload.warehouse : '';
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let amount = payload.amount ? payload.amount : '';
    let url = `reports/purchases?supplier=${supplier}&warehouse=${warehouse}&start=${start}&end=${end}&amount=${amount}`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  getChequeReports({}, payload) {
    // let supplier = payload.supplier ? payload.supplier : "";
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let cheqStatus = payload.cheqStatus ? payload.cheqStatus : '';
    let cheqFor = payload.cheqFor ? payload.cheqFor : '';
    // let url = `reports/cheques?`;
    let url = `reports/cheques?start=${start}&end=${end}&cheqFor=${cheqFor}&cheqStatus=${cheqStatus}`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  getPurchaseOrderReports({}, payload) {
    let supplier = payload.supplier ? payload.supplier : '';
    let warehouse = payload.warehouse ? payload.warehouse : '';
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let status = payload.status ? payload.status : '';
    let url = `reports/purchases-orders?supplier=${supplier}&warehouse=${warehouse}&start=${start}&end=${end}&status=${status}`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  getPurchaseReturnReports({}, payload) {
    let supplier = payload.supplier ? payload.supplier : '';
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let status = payload.status ? payload.status : '';
    let url = `reports/purchases-returns?supplier=${supplier}&start=${start}&end=${end}&status=${status}`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  getOutofStockReports({}, payload) {
    let warehouse = payload.warehouse ? payload.warehouse : '';
    let product = payload.product ? payload.product : '';
    let unit = payload.unit ? payload.unit : '';
    let url = `reports/stocks/out-of-stocks?warehouse=${warehouse}&product=${product}&unit=${unit}`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  getSalesReports({}, payload) {
    let customer = payload.customer ? payload.customer : '';
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let biller = payload.biller ? payload.biller : '';
    let shop = payload.shop ? payload.shop : '';
    let product = payload.product ? payload.product : '';
    let saleType = payload.saleType ? payload.saleType : '';
    let url = `reports/sales?customer=${customer}&start=${start}&end=${end}&biller=${biller}&shop=${shop}&product=${product}&saleType=${saleType}`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  getLowStockReports({}, payload) {
    let warehouse = payload.warehouse ? payload.warehouse : '';
    let product = payload.product ? payload.product : '';
    let unit = payload.unit ? payload.unit : '';
    let url = `reports/stocks/low-stocks?warehouse=${warehouse}&product=${product}&unit=${unit}`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  // Warehouse Product Management Report

  getPurchaseReportProductManagement({}, payload) {
    let product = payload.product ? payload.product : '';
    let warehouse = payload.warehouse ? payload.warehouse : '';
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let type = payload.type ? payload.type : '';

    let url = `reports/product-manage?product=${product}&warehouse=${warehouse}&start=${start}&end=${end}&type=purchase`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  getPurchaseOrderReportProductManagement({}, payload) {
    let product = payload.product ? payload.product : '';
    let warehouse = payload.warehouse ? payload.warehouse : '';
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let type = payload.type ? payload.type : '';
    let url = `reports/product-manage?product=${product}&warehouse=${warehouse}&start=${start}&end=${end}&type=purchaseorder`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  getPurchaseReturnReportProductManagement({}, payload) {
    let product = payload.product ? payload.product : '';
    let warehouse = payload.warehouse ? payload.warehouse : '';
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let type = payload.type ? payload.type : '';
    let url = `reports/product-manage?product=${product}&warehouse=${warehouse}&start=${start}&end=${end}&type=purchasereturn`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  getWarehouseStockReportProductManagement({}, payload) {
    let product = payload.product ? payload.product : '';
    let warehouse = payload.warehouse ? payload.warehouse : '';
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let type = payload.type ? payload.type : '';
    let url = `reports/product-manage?product=${product}&warehouse=${warehouse}&start=${start}&end=${end}&type=warehousestock`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  // Shop Product Management Report

  getProductTransferReportProductManagement({}, payload) {
    let product = payload.product ? payload.product : '';
    let shop = payload.shop ? payload.shop : '';
    let warehouse = payload.warehouse ? payload.warehouse : '';
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let type = payload.type ? payload.type : '';

    let url = `reports/product-manage?product=${product}&shop=${shop}&warehouse=${warehouse}&start=${start}&end=${end}&type=producttransfer`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  // Shop to Shop Product Management Report

  getShopToShopTransferReportProductManagement({}, payload) {
    let product = payload.product ? payload.product : '';
    let shop = payload.shop ? payload.shop : '';
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let type = payload.type ? payload.type : '';

    let url = `reports/product-manage?product=${product}&shop=${shop}&start=${start}&end=${end}&type=shoptoshoptransfer`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  getShopStockReportProductManagement({}, payload) {
    let product = payload.product ? payload.product : '';
    let shop = payload.shop ? payload.shop : '';
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let type = payload.type ? payload.type : '';
    let url = `reports/product-manage?product=${product}&shop=${shop}&start=${start}&end=${end}&type=shopstock`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  getShopSalesReportProductManagement({}, payload) {
    let product = payload.product ? payload.product : '';
    let shop = payload.shop ? payload.shop : '';
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let type = payload.type ? payload.type : '';
    let url = `reports/product-manage?product=${product}&shop=${shop}&start=${start}&end=${end}&type=sales`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetShopOverviewReport({}, payload) {
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let url = `reports/overview/shop?start=${start}&end=${end}`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  GetWarehouseOverviewReport({}, payload) {
    let start = payload.start ? payload.start : '';
    let end = payload.end ? payload.end : '';
    let url = `reports/overview/warehouse?start=${start}&end=${end}`;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
};
